module.exports = __webpack_public_path__ + "media/images/common-nav/state-parks/washington-661326a9043dfe94da412674818db3d0.jpg";